// extracted by mini-css-extract-plugin
export default {"btn":"BzJITS6yeYQm2oLp6J6_","btn-label":"h7U8Bl4DxJQ0P4fZeeFG","btnLabel":"h7U8Bl4DxJQ0P4fZeeFG","menu-item":"k6o_0LYVR4Dj2aw71J7k","menuItem":"k6o_0LYVR4Dj2aw71J7k"};